import { useState, useEffect } from "react";
import axios from '../../lib/axios'
import errorHandler from "../../helpers/errorHandler";

const useFetchUserBToken = () => {
    const [user, setUser] = useState([])
    const [loading, setLoading] = useState(false)

    const handleFetch = async () => {
        try {
            const options = {
                url: `/users/users/`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            setLoading(true)
            const { data } = await axios(options)

            setUser(data.data)
            setLoading(false)
        } catch (err) {
            setLoading(false)
            errorHandler({ err: err?.response?.data || err })
        }
    }

    useEffect(() => {
        handleFetch()
    }, [])

    return { user, loadingFetchClassTypes: loading }
}

export default useFetchUserBToken